export enum CELL_STATE {
  DEAD,
  ALIVE,
  HOVERED,
  STARVING
}

export enum PREFABS {
  POINT,
  BEEHIVE,
  BEEHIVE_WITH_TAIL,
  MIRRORED_TABLE,
  BLINKER,
  TUMBLER,
  QUEEN_BEE_SHUTTLE,
  GLIDER,
  R_PENTOMINO,
  QUEEN_BEE,
  ACORN,
  PI_HEPTOMINO,
  GOSPER_GLIDER_GUN,
  COPPERHEAD,
  LOAFER,
  TOAD,
  FIGURE_EIGHT
}

const SHAPES: Record<PREFABS, CELL_STATE[][]> = {
  [PREFABS.POINT]: [[CELL_STATE.ALIVE]],
  [PREFABS.BEEHIVE]: [
    [CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.ALIVE, CELL_STATE.DEAD],
    [CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.ALIVE],
    [CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.ALIVE, CELL_STATE.DEAD],
  ],
  [PREFABS.BEEHIVE_WITH_TAIL]: [
    [
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
    ],
    [
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
    ],
    [
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
    ],
    [
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
    ],
    [
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.ALIVE,
    ],
  ],
  [PREFABS.MIRRORED_TABLE]: [
    [
      CELL_STATE.ALIVE,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.ALIVE,
    ],
    [
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
    ],
    [
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
    ],
    [
      CELL_STATE.ALIVE,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.ALIVE,
    ],
  ],
  [PREFABS.BLINKER]: [
    [CELL_STATE.ALIVE],
    [CELL_STATE.ALIVE],
    [CELL_STATE.ALIVE],
  ],
  [PREFABS.TUMBLER]: [
    [
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
    ],
    [
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
    ],
    [
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
    ],
    [
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
    ],
    [
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
    ],
  ],
  [PREFABS.QUEEN_BEE_SHUTTLE]: [
    [
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
    ],
    [
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
    ],
    [
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.ALIVE,
    ],
    [
      CELL_STATE.ALIVE,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.ALIVE,
    ],
    [
      CELL_STATE.ALIVE,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
    ],
    [
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
    ],
    [
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
    ],
  ],
  [PREFABS.GLIDER]: [
    [CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.DEAD],
    [CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.ALIVE],
    [CELL_STATE.ALIVE, CELL_STATE.ALIVE, CELL_STATE.ALIVE],
  ],
  [PREFABS.R_PENTOMINO]: [
    [CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.ALIVE],
    [CELL_STATE.ALIVE, CELL_STATE.ALIVE, CELL_STATE.DEAD],
    [CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.DEAD],
  ],
  [PREFABS.QUEEN_BEE]: [
    [CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD],
    [CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.DEAD],
    [CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.DEAD],
    [CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.ALIVE],
    [CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.DEAD],
    [CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.DEAD],
    [CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD],
  ],
  [PREFABS.ACORN]: [
    [CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD],
    [CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD],
    [CELL_STATE.ALIVE, CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.ALIVE, CELL_STATE.ALIVE],
  ],
  [PREFABS.PI_HEPTOMINO]: [
    [CELL_STATE.ALIVE, CELL_STATE.ALIVE, CELL_STATE.ALIVE],
    [CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.ALIVE],
    [CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.ALIVE],
  ],
  [PREFABS.GOSPER_GLIDER_GUN]: [
    [
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
    ],
    [
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
    ],
    [
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.ALIVE,
    ],
    [
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.ALIVE,
    ],
    [
      CELL_STATE.ALIVE,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
    ],
    [
      CELL_STATE.ALIVE,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
    ],
    [
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
    ],
    [
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
    ],
    [
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.ALIVE,
      CELL_STATE.ALIVE,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
      CELL_STATE.DEAD,
    ],
  ],
  [PREFABS.COPPERHEAD]: [
    [CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.ALIVE, CELL_STATE.DEAD],
    [CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD],
    [CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD],
    [CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.ALIVE],
    [CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.ALIVE],
    [CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD],
    [CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.ALIVE],
    [CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.ALIVE, CELL_STATE.DEAD],
    [CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.ALIVE, CELL_STATE.ALIVE, CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.DEAD],
    [CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD],
    [CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD],
    [CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD],
  ],
  [PREFABS.LOAFER]: [
    [CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.ALIVE],
    [CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.ALIVE, CELL_STATE.DEAD],
    [CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD],
    [CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD],
    [CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.ALIVE],
    [CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.ALIVE, CELL_STATE.ALIVE],
    [CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD],
    [CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.DEAD],
    [CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.ALIVE],
  ],
  [PREFABS.TOAD]: [
    [CELL_STATE.ALIVE, CELL_STATE.DEAD],
    [CELL_STATE.ALIVE, CELL_STATE.ALIVE],
    [CELL_STATE.ALIVE, CELL_STATE.ALIVE],
    [CELL_STATE.DEAD, CELL_STATE.ALIVE],
  ],
  [PREFABS.FIGURE_EIGHT]: [
    [CELL_STATE.ALIVE, CELL_STATE.ALIVE, CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD],
    [CELL_STATE.ALIVE, CELL_STATE.ALIVE, CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD],
    [CELL_STATE.ALIVE, CELL_STATE.ALIVE, CELL_STATE.ALIVE, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD],
    [CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.ALIVE, CELL_STATE.ALIVE],
    [CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.ALIVE, CELL_STATE.ALIVE],
    [CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.DEAD, CELL_STATE.ALIVE, CELL_STATE.ALIVE, CELL_STATE.ALIVE],
  ]
};

export default SHAPES
